import { State } from 'src/redux/reducer';

export const initKeycloakSelector = (state: State) =>
  state.initilizationKeycloak.isInitilization;
